export function formatINR(n) {
  if (n == null || n === "") return "—";
  const num = Number(n);
  if (isNaN(num)) return n;
  if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹${(num / 100000).toFixed(1)} L`;
  return `₹${num.toLocaleString("en-IN")}`;
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  if (s < 604800) return `${Math.floor(s / 86400)}d ago`;
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}

export function tempColor(t) {
  return {
    hot: "bg-red-500/15 text-red-400 border-red-500/30",
    qualified: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    warm: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    cold: "bg-slate-500/15 text-slate-400 border-slate-500/30",
  }[t] || "bg-slate-500/15 text-slate-400 border-slate-500/30";
}

export function scoreColor(s) {
  if (s >= 76) return "text-red-400";
  if (s >= 51) return "text-emerald-400";
  if (s >= 26) return "text-amber-400";
  return "text-slate-400";
}

export function stageLabel(s) {
  return (s || "").replace(/_/g, " ");
}

export function stageBadge(s) {
  const won = s === "CLOSED_WON";
  const lost = s === "CLOSED_LOST";
  const hot = ["HOT", "ADMIN_REVIEW"].includes(s);
  if (won) return "bg-emerald-500/15 text-emerald-400 border-emerald-500/30";
  if (lost) return "bg-slate-600/20 text-slate-400 border-slate-600/40";
  if (hot) return "bg-red-500/15 text-red-400 border-red-500/30";
  return "bg-blue-500/10 text-blue-300 border-blue-500/25";
}

export function typeBadge(t) {
  return t === "ASSOCIATE"
    ? "bg-emerald-500/15 text-emerald-400 border-emerald-500/30"
    : "bg-blue-500/15 text-blue-400 border-blue-500/30";
}
